export default {
    id: null,
    // Contact Details
    name: '',
    email: '',
    phone: '',
    place: {},
    address: {},

    // Building
    buildingType: null,
    homeSqft: null,
    homeFloors: null,
    homeFloorsInput: null,
    homeBasement: null,
    homeBasementFinished: null,
    homeBasementCeiling: null,
    homeBedrooms: null,
    homeBathrooms: null,
    homeImageUrl: null,
    homeMapImageUrl: null,

    // Communications
    phoneService: null,
    internetInHome: null,

    // Pets
    hasPets: [],
    petsFreeRoam: null,
    dogsOver80: null,

    // Concerns
    additionalThreats: [],
    homeAwayConcern: null,
    peopleThingsConcern: null,
    automationInterests: [],
    automationQuantities: {
        FrontDoorCamera: 0,
        InteriorCameras: 0,
        RemoteDoorLocks: 0,
        SmartThermostat: 0,
        LightingControl: 0,
        Fire: 0,
        CarbonMonoxide: 0,
        Flooding: 0,
        LowTemperature: 0
    },

    protectionLevel: null,

    homeStairwaysQty: null,
    homeStairwaysQtyInput: null,
    homeDoorsQty: null,
    homeDoorsQtyMore: null,
    accessibleAreasQty: null,

    roomConcerns: null,
    roomConcernsQty: null,
    roomConcernsQtyInput: null,

    areasOfConcern: []
}
